import ContactInfo from "./ContactInfo";
import ContactMap from "./ContactMap";
import ContainerGlob from "@/app/[locale]/componentsGLob/ContainerGlob";
import CManagerCard from "./CManagerCard";
import { useTranslation } from "react-i18next";

export default function MappInfo() {
  const { t } = useTranslation("info");

  return (
    <ContainerGlob className="py-12">
      <h2
        id="info"
        className="text-center text-4xl font-extrabold mb-10 tracking-tight text-gray-900"
      >
        {t("mappInfo.titlePart1")}{" "}
        <span className="text-primary">{t("mappInfo.titlePart2")}</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-6 items-start">
        {/* Mappa */}
        <div className="h-full">
          <div className="h-full w-full rounded-lg overflow-hidden shadow border">
            <ContactMap />
          </div>
        </div>

        {/* Sezioni a destra */}
        <div className="flex flex-col gap-6 h-full">
          <ContactInfo />
          <CManagerCard />
        </div>
      </div>
    </ContainerGlob>
  );
}
